function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { sdkLogger } from '../../logger';
import { ApplicationExclusiveRole, AudioExclusiveRole, SharedRole, TextExclusiveRole, VideoExclusiveRole } from './role.enum';
export var AudioRole = _object_spread({}, AudioExclusiveRole, SharedRole);
export var VideoRole = _object_spread({}, VideoExclusiveRole, SharedRole);
export var TextRole = _object_spread({}, TextExclusiveRole, SharedRole);
export var ApplicationRole = _object_spread({}, ApplicationExclusiveRole, SharedRole);
/***
 *
 * Adapts DASH Track Roles to CVSDK Track Roles
 *
 ***/ export function adaptDashRole(role) {
    // According to DASH spec, no role can be assumed to be main
    if (!role) {
        return AudioRole.Main;
    }
    var playerRole = role;
    if ([
        'forced_subtitle',
        'forced-subtitle'
    ].includes(role.toLowerCase())) {
        playerRole = TextRole.ForcedSubtitle;
    } else if (role === 'public.accessibility.describes-video') {
        // HLS CHARACTERISTICS attribute e.g. CHARACTERISTICS="public.accessibility.describes-video"
        playerRole = AudioRole.Description;
    } else if (role.includes('-')) {
        var roleArray = role.split('-');
        var roleArrayUpperCase = roleArray.map(function(r) {
            return r.charAt(0).toUpperCase() + r.slice(1);
        });
        playerRole = roleArrayUpperCase.join('');
    } else {
        // Safari returning 'description' contrary to MDN spec: https://developer.mozilla.org/en-US/docs/Web/API/AudioTrack/kind
        // eliminating all variations of 'description/descriptions' and always return "Description"
        if (role.toLowerCase() === 'descriptions') {
            playerRole = TextRole.Description;
        } else {
            playerRole = role.charAt(0).toUpperCase() + role.slice(1);
        }
    }
    var allRoles = _object_spread({}, TextRole, AudioRole, VideoRole, ApplicationRole);
    if (playerRole in allRoles) {
        return playerRole;
    } else {
        sdkLogger.warn("Player track role ".concat(role, " was unable to be adapted to Role Enum"));
    }
    return AudioRole.Unknown;
}
export function hasAudioDescriptionRole(roles) {
    if (!roles || !roles.length) {
        return false;
    }
    return roles.includes(AudioRole.Description);
}
export function hasMainRole(roles) {
    // Tracks without roles should be considered Main
    if (!roles || !roles.length) {
        return true;
    }
    return roles.includes(AudioRole.Main);
}

//# sourceMappingURL=role.js.map